
import { FETCH_ISICS, FETCHED_ISICS, SEARCH_ISICS, SELECT_ISIC, SELECT_ALL_ISICS } from './IsicsActions'




const isicsReducer = (state = { searchParameter: "", isics: [], isFetching: false }, action) => {

    const searchIsics = (isic) => {
        let isicTested = { ...isic, isMatchSearch: false }
        if (action.searchParameter === "") {
            isicTested.isMatchSearch = true;
            return isicTested;
        }

        if ((isic.c + ' ' + isic[action.activeLangCode]).toLowerCase().includes(action.searchParameter ? action.searchParameter.toLowerCase() : state.searchParameter.toLowerCase())) {
            isicTested.isMatchSearch = true;
        }

        return isicTested;
    }


    const sort = (a, b) => {
        var x = a.uiValue.toLowerCase();
        var y = b.uiValue.toLowerCase();
        if (x < y) {return -1;}
        if (x > y) {return 1;}
        return 0;
    }

    switch (action.type) {
        case FETCH_ISICS:
            return {
                ...state,
                isFetching: true
            }
        case FETCHED_ISICS:
            return {
                isFetching: false,
                searchParameter: "",
                isics: action.data.map(t => ({ ...t, isMatchSearch: true, uiValue: t.c + " " + t.n })).sort(sort)
            }
        case SEARCH_ISICS:
            return {
                ...state,
                searchParameter: action.searchParameter,
                isics: state.isics.map(searchIsics)
            }
        case SELECT_ISIC: {
            const selectedIsic = state.isics.filter(x => x.id === action.isicId)[0];
            const newSelection = !selectedIsic.selected;
            return {
                ...state,
                isics: state.isics.map((isic) => {
                    if (isic.c.startsWith(selectedIsic.c)) {
                        return { ...isic, selected: newSelection };
                    }
                    return isic;
                })
            };
        }
        case SELECT_ALL_ISICS:
            return {
                ...state,
                isics: state.isics.map((isic) => {
                    return { ...isic, selected: action.selectionStatus === "ALL" || action.selectionStatus === "SOME" ? false : true }
                })
            }
        default:
            return state;
    }
}

export default isicsReducer;


// WEBPACK FOOTER //
// ./src/features/modules/survey-data-visualization/isics/IsicsReducer.js